import { Radar, mixins } from "vue-chartjs";

export default {
  extends: Radar,
  mixins: [mixins.reactiveProp],
  props: ["chartData"],

  computed: {
    options() {
      return {
        scale: {
          display: true
        },
        title: {
          display: true,
          text: "Stroke/Facility Races Count Chart"
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true
          /* callbacks: {
                         label: (tooltipItem, data) => {
                             var n = new Date(0, 0);
                             n.setSeconds(+tooltipItem.yLabel * 60);
                             //var temp = this.chartData.datasets[tooltipItem.datasetIndex];
                            
                             
                             
                             
                             return (
                                 this.chartData.datasets[tooltipItem.datasetIndex].label +" " + this.chartData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].stroke +
                                 " - " +
                                 n.toTimeString().slice(0, 8) +
                                 "\n - " + this.chartData.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].comments.replace(".cl2","")
                             );
                         }
                     }*/
        }
      };
    }
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
